import React from 'react'
import HomeBanner from "../../components/sections/front/Authentication/Home/HomeBanner"
import HomeFeature from "../../components/sections/front/Authentication/Home/HomeFeature"
import HomeAbout from "../../components/sections/front/Authentication/Home/HomeAbout"
import HomeTestimonial from "../../components/sections/front/Authentication/Home/HomeTestimonial"
import HomeConfidence from "../../components/sections/front/Authentication/Home/HomeConfidence"
import HomeFaq from "../../components/sections/front/Authentication/Home/HomeFaq"

const Home = () => {
  return (
    <>
      <HomeBanner />
      <HomeFeature />
      <HomeAbout />
      <HomeTestimonial />
      <HomeConfidence />
      <HomeFaq/>
    </>
  )
}

export default Home